export class HistoryModel {

  uid: number;
  dateTime: string;
  log: string;
  userName: string;
  
  constructor() {

  }
}